import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';

/* Actions */
import { Logout } from 'src/app/core/store/auth/auth.action';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	constructor(private router: Router, private store: Store) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		return next.handle(request).pipe(catchError((response) => this.handleAuthError(response)));
	}

	private handleAuthError(err: HttpErrorResponse): Observable<any> {
		// check if unauthorized
		if (err.status === 401 && err.error.message !== 'Invalid username or password') {
			// check router url to prevent infinite loop
			if (this.router.url !== '/login') {
				this.store.dispatch(new Logout());
			}

			return EMPTY;
		}

		return throwError(err);
	}
}
